export default __webpack_public_path__ + "static/media/pascale-allotey.e316705f.png";